import { AxiosResponse } from 'axios';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { useLocation, useNavigate } from 'react-router-dom';
import useApi from 'hooks/useApi';
import useErrorLog from 'hooks/useErrorLog';

import { useSubscribeStatus } from 'hooks/useSubscribe';
import useAlertConfirmStore from 'zustands/useAlertConfirmStore';
import useLoadingStore from 'zustands/useLoadingStore';
import useStoreStore from 'zustands/useStoreStore';
import useUserStore from 'zustands/useUserStore';

let LOCATION = '';

const StatusChecker = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { userToken, userType, managerInfo, setManagerInfo, subscribePlanName, setSubscribePlanName, ISP } =
    useUserStore();
  const { setLoadingState } = useLoadingStore();
  const { storeSeq, setStoreInfo } = useStoreStore();
  const { setModalState } = useAlertConfirmStore();

  const { getSubscribeStatus, status } = useSubscribeStatus();
  const { webApiNode } = useApi();
  const { checkErrorLog } = useErrorLog();

  // 접속한 사업장에서의 상태 체크
  const checkEmpStatus = async () => {
    try {
      if (!managerInfo.empSeq) return false;
      setLoadingState({ isFetchLoading: true });
      const { data }: AxiosResponse['data'] = await webApiNode('post', `/auth/empWorkCheck`, {
        EMP_SEQ: managerInfo.empSeq,
      });

      if (data.resultCode === 0) {
      } else if (data.resultCode === 5) {
        setManagerInfo({
          empSeq: 0,
          payShow: false,
          storePayShow: false,
          otherPayShow: false,
          calendarEdit: false,
          recievePush: false,
        });
        setStoreInfo({ storeSeq: '', storeName: '', storeSeqNumber: 0, isBN: false });
        navigate('/business-establishment-choice');
        return setModalState({
          isModalShow: true,
          title: '사업장 선택 해제',
          desc: `아래 중 하나의 사유\n- 해당 사업주의 스탠다드 구독권 미보유\n- 해당 사업장의 폐업처리\n- 해당 사업장에서 퇴사처리`,
        });
      } else {
        throw new Error(data.resultMsg);
      }
    } catch (err) {
      checkErrorLog(err, ' /auth/empWorkCheck');
    } finally {
      setLoadingState({ isFetchLoading: false });
    }
  };

  // 사업주 구독 상태 체크
  const checkSubscribeStatus = async () => {
    const excludedScreen = ['/login', '/account-settings', '/paystub-employee-login', '/paystub-employee-preview'];
    if (!excludedScreen.includes(location.pathname) && !isMobile) {
      getSubscribeStatus();
    }
  };

  // 페이지 이동 시 마다 구독 상태 체크
  React.useEffect(() => {
    const publicPages = [
      '/login',
      '/paystub-employee-login',
      '/paystub-employee-preview',
      '/selectedStore/payStatement/authMember',
    ];

    if (!ISP && LOCATION !== location.pathname) {
      LOCATION = location.pathname;
      // 공개 페이지는 인증 체크 생략
      if (publicPages.includes(location.pathname)) {
        return;
      }
      if (userToken && userToken.length > 0) {
        if (userType === '1') {
          checkSubscribeStatus();
        } else {
          if (managerInfo.empSeq !== 0 && storeSeq) checkEmpStatus();
        }
      }
    }
  }, [location.pathname]);

  React.useEffect(() => {
    let NAME = '무료';
    if (status.length > 0) {
      if (status[0].pp_name === 'INACTIVE' || status[0].pp_name === 'CANCEL') NAME = '무료';
      NAME = status[0].pp_name;
    }
    if (subscribePlanName !== NAME) {
      setSubscribePlanName(NAME);
    }
  }, [status]);

  return null;
};

export default StatusChecker;
